import z from 'zod'

import { ParkingSpotEquipments } from '../types'

export const parkingSpotEquipmentEnum = z.enum(ParkingSpotEquipments)

export const joinQueueBodySchema = z.object({
  equipmentWishes: z.array(parkingSpotEquipmentEnum).min(1),
  additionalInformation: z.string(),
  costPoolId: z.number(),
})

export type JoinQueueBody = z.infer<typeof joinQueueBodySchema>

export const parkingSpotResponseSchema = z.object({})

export const querySchema = z.object({
  include: z.enum(['all', 'own']).optional(),
})

export const terminateReservationBodySchema = z.object({
  endDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'endDate must be YYYY-MM-DD'),
  rentableParkingSpotId: z.number(),
})

export type TerminateReservationBody = z.infer<
  typeof terminateReservationBodySchema
>

export const cancelReservationBodySchema = z.object({
  rentableParkingSpotId: z.number(),
})

export type CancelReservationBody = z.infer<typeof cancelReservationBodySchema>

export const reservationBodySchema = z.object({
  startDate: z.string().min(1),
  endDate: z.string().nullable().optional(),
  rentableParkingSpotId: z.number(),
})

export type ReservationBody = z.infer<typeof reservationBodySchema>

export const reservationResponseSchema = z.object({}).passthrough()
export type ReservationResponse = z.infer<typeof reservationResponseSchema>

export const paramsSchema = z.object({ contractUuid: z.string() })

export const bodySchema = z.object({
  startDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'startDate must be YYYY-MM-DD'),
  endDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable(),
  rentableParkingSpotId: z.number(),
})

export const queueItemSchema = z.object({
  id: z.number(),
  equipmentWishes: z.array(parkingSpotEquipmentEnum),
  kind: z.enum(['own', 'other']),
  queuePosition: z.number(),
  additionalInformation: z.string().nullable().optional(),
  costPoolId: z.number(),
})

export const coreQueueItemsSchema = z.array(queueItemSchema)

export const deleteParamsSchema = z.object({
  contractUuid: z.string(),
  queueId: z.coerce.number(),
  costPoolId: z.coerce.number(),
})

export type bodySchemaType = z.infer<typeof bodySchema>

export const voidSchema = z.void()
